import Chip from '@material-ui/core/Chip';
import blue from '@material-ui/core/colors/blue';
import React from 'react';
import { ReactComponent as CloseGrey } from '../../assets/close-grey.svg';
import { ChipRendererArgs } from './types';

const ChipRenderer = (args: ChipRendererArgs, key: number) => {
  const {
    text,
    isFocused,
    isDisabled,
    isReadOnly,
    handleClick,
    handleDelete,
    className,
    chipErrorClassName,
    validInput,
  } = args;

  return (
    <Chip
      size="small"
      key={key}
      className={validInput(text) ? className : chipErrorClassName}
      style={{
        pointerEvents: isDisabled || isReadOnly ? 'none' : undefined,
        backgroundColor: isFocused ? blue[300] : undefined,
      }}
      onClick={handleClick}
      onDelete={handleDelete}
      label={text}
      deleteIcon={<CloseGrey />}
    />
  );
};

export default ChipRenderer;
